import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllBKVersions,
  getAllDeployEnvs,
  getAllDeployVersions,
  getAllKafkaVersions,
  getAllPulsarVersions,
  getAllZKVersions,
  getBacklogRetentionPolicy,
  getClusterUsage,
  getPermissions,
  getSchemaPolicy,
} from '@/services/dictService';

const initialState = {
  deployEnvs: [],
  clusterEnvs: [],
  BKVersions: [],
  clusterUsage: [],
  ZKVersions: [],
  deployVersions: [],
  pulsarVersions: [],
  kafkaVersions: [],
  permissions: [],
  backlogRetentionPolicy: [],
  schemaPolicy: [],
};

// 兼容老字典 不合并
export const fetchAllDeployEnvs = createAsyncThunk('dict/fetchAllDeployEnvs', async () => {
  const response = await getAllDeployEnvs();
  return response.data;
});

// export const fetchAllClusterEnvs = createAsyncThunk('dict/fetchAllClusterEnvs', async () => {
//   const response = await getAllClusterEnvs();
//   return response.data;
// });

export const fetchAllBKVersions = createAsyncThunk('dict/fetchAllBKVersions', async () => {
  const response = await getAllBKVersions();
  return response.data;
});

export const fetchClusterUsage = createAsyncThunk('dict/fetchClusterUsage', async () => {
  const response = await getClusterUsage();
  return response.data;
});
export const fetchAllZKVersions = createAsyncThunk('dict/fetchAllZKVersions', async () => {
  const response = await getAllZKVersions();
  return response.data;
});

export const fetchAllDeployVersions = createAsyncThunk('dict/fetchAllDeployVersions', async () => {
  const response = await getAllDeployVersions();
  return response.data;
});

export const fetchAllPulsarVersions = createAsyncThunk('dict/fetchAllPulsarVersions', async () => {
  const response = await getAllPulsarVersions();
  return response.data;
});

export const fetchAllKafkaVersions = createAsyncThunk('dict/fetchAllKafkaVersions', async () => {
  const response = await getAllKafkaVersions();
  return response.data;
});

export const fetchPermissions = createAsyncThunk('dict/fetchPermissions', async () => {
  const response = await getPermissions();
  return response.data;
});

export const fetchBacklogRetentionPolicy = createAsyncThunk(
  'dict/fetchBacklogRetentionPolicy',
  async () => {
    const response = await getBacklogRetentionPolicy();
    return response.data;
  },
);

export const fetchSchemaPolicy = createAsyncThunk('dict/fetchSchemaPolicy', async () => {
  const response = await getSchemaPolicy();
  return response.data;
});

export const dictSlice = createSlice({
  name: 'dict',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllDeployEnvs.fulfilled, (state, action) => {
        state.deployEnvs = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchAllBKVersions.fulfilled, (state, action) => {
        state.BKVersions = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchClusterUsage.fulfilled, (state, action) => {
        state.clusterUsage = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchAllZKVersions.fulfilled, (state, action) => {
        state.ZKVersions = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchAllDeployVersions.fulfilled, (state, action) => {
        state.deployVersions = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchAllPulsarVersions.fulfilled, (state, action) => {
        state.pulsarVersions = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchAllKafkaVersions.fulfilled, (state, action) => {
        state.kafkaVersions = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.permissions = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchBacklogRetentionPolicy.fulfilled, (state, action) => {
        state.backlogRetentionPolicy = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchSchemaPolicy.fulfilled, (state, action) => {
        state.schemaPolicy = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      });
  },
});

export default dictSlice.reducer;
